import { apiClient } from "./apiClient";

export const optionsApi = {
  listAll: () => apiClient.get("/options").then((r) => r.data),
  list: (listKey) => apiClient.get(`/options/${listKey}`).then((r) => r.data),
  create: (listKey, payload) => apiClient.post(`/options/${listKey}`, payload).then((r) => r.data),
  /* THE MANAGE LIST: the ordinary one plus what was put away (#417).
     Opt-in, so no picker starts offering put-away values by inheriting a
     wider list. */
  listForManaging: (listKey) =>
    apiClient.get(`/options/${listKey}?include_retired=true`).then((r) => r.data),
  retire: (listKey, optionId) => apiClient.delete(`/options/${listKey}/${optionId}`).then((r) => r.data),
  restore: (listKey, optionId) =>
    apiClient.put(`/options/${listKey}/${optionId}`, { is_active: true }).then((r) => r.data),

  /*
   * Fold one value into another, rewriting the records that name it
   * (#417 part 3).
   *
   * A VALUE rather than an option_id, because built-in defaults are not
   * rows -- the server sends them with a null option_id -- so the
   * commonest merge, a typo'd "Frames" into the built-in "Frame", has no
   * id to point at.
   *
   * ALSO THE RENAME. A target that does not exist yet is created, so
   * "rename" is a merge into a new name. That is the only correct way to
   * rename here: consumers store the TEXT, so rewriting the records IS
   * the rename, and the endpoint does both or neither.
   */
  merge: (listKey, optionId, intoValue) =>
    apiClient
      .post(`/options/${listKey}/${optionId}/merge`, { into_value: intoValue })
      .then((r) => r.data),
};
